import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';

import { BaseComponent } from '~Interfaces/basecomponent';

import { UtilisateurService } from '~Services/utilisateur.service';
import { Constantes } from '~Tools/Constantes';
import { Converters } from '~Tools/Converters';
import { DateConfig } from '~Tools/DateConfig';

import { IMyDateModel } from 'angular-mydatepicker';

/**
 * Composant de recherche pour la facturation
 * @extends BaseComponent
 * @implements OnInit
 */
@Component({
  selector: 'app-recherche-facturation',
  templateUrl: './recherche-facturation.component.html',
  styleUrls: ['./recherche-facturation.component.scss']
})
export class RechercheFacturationComponent extends BaseComponent implements OnInit {

    afficherFiltres: boolean = true;
    listeFournisseurs: any[] = [];

    datePickerOptions: any = DateConfig.datePickerOptions;
    datePickerLocale: string = DateConfig.datePickerLocale;

    dateDebut: IMyDateModel = null;
    dateFin: IMyDateModel = null;
    @Output() readonly rechercheEvent: EventEmitter<any> = new EventEmitter<any>();

    /**
     * Constructeur
     */
    constructor(@Inject(UtilisateurService) private utilisateurService: UtilisateurService) { super(); }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
        this.initDates();
        this.utilisateurService.obtenirUtilisateurCourant().subscribe((retour: any) => {
            if (retour && retour.Result) {
                this.listeFournisseurs = this.filtrerListeFournisseur(retour.Result.ListeFournisseurs);
                this.selectionnerLesFournisseurs(true);
            }
        });
    }

    /**
     * Obtenir les codes fournisseurs s�lectionn�s
     */
    get codesFournisseur(): string[] {
        return this.listeFournisseurs.filter((o) => { return o.checked; }).map((o) => { return o.Code; });
    }

    /**
     * Lancer la recherche
     */
    rechercher(): void {
        // Lancer la recherche
        if (this.codesFournisseur && this.codesFournisseur.length > 0) {
            this.rechercheEvent.emit({
                DateDebut: this.dateDebut.singleDate.jsDate,
                DateFin: this.dateFin.singleDate.jsDate,
                CodeFournisseurs: this.codesFournisseur
            });
        }
    }

    /**
     * S�lectionner tout les fournisseurs
     * @param e
     */
    toutSelectionner(e) {
        let checked: boolean = e.target.checked;
        this.selectionnerLesFournisseurs(checked);
    }

    /**
     * S�lectionner ou d�s�lectionner les fournisseurs
     * @param selectionner
     */
    selectionnerLesFournisseurs(selectionner: boolean) {
        this.listeFournisseurs.forEach((o) => { o.checked = selectionner; });
    }

    /**
     * Filtrer la liste des fournisseurs
     * @param listeFournisseur
     */
    private filtrerListeFournisseur(listeFournisseur): any[] {
        if (listeFournisseur && listeFournisseur.length) {
            // Liste uniquement les founisseurs point relais
            var listeFournisseurs = listeFournisseur as any[];
            listeFournisseurs = listeFournisseurs.filter((f) => {
                return f.CategorieFournisseurCode == Constantes.CATEGORIE_POINT_RELAIS;
            });
            return listeFournisseurs;
        }
        return [];
    }

    /**
     * Initialiser les dates
     */
    private initDates() {
        let dateDebut = new Date();
        dateDebut.setMonth(dateDebut.getMonth() - 1);

        let dateFin = new Date();

        this.dateDebut = { isRange: false, singleDate: { jsDate: dateDebut } };
        this.dateFin = { isRange: false, singleDate: { jsDate: dateFin } };
    }
}
